import React from "react";
import { Input } from "@windmill/react-ui";

const InputDefault = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChange,
  onBlur
}) => {
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    onBlur: onBlur,
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength}!`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength}!`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }
      return true;
    },
  };

const handleInput = (e) => {
    if (maxLength && e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }
  };

  return (
    <>
      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        onInput={handleInput} // Restricts input to letters only
        name={name}
        value={value}
        readOnly={readOnly}
        autoComplete="off"
        onChange={onChange}
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputDefault;
